module.exports = __webpack_public_path__ + "static/img/case_13.d604999.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_13.jpg
// module id = Cr3A
// module chunks = 0